import React from 'react';
import { ChevronDown  } from 'lucide-react';
import { EQUIPMENT_TYPES } from '../../utils/constants';

const EquipmentSelector = ({ 
  darkMode, 
  activeAccordion, 
  setActiveAccordion, 
  handleEquipmentClick,
  title = "Kaynaklar"
}) => {
  return (
    <div className={`border ${darkMode ? 'border-gray-600' : 'border-gray-300'} rounded-lg overflow-hidden w-full`}>
      <div 
        className={`p-4 ${darkMode ? 'bg-gray-700 text-gray-200' : 'bg-gray-100 text-gray-800'} cursor-pointer flex justify-between items-center`}
        onClick={() => setActiveAccordion(activeAccordion === 'equipment' ? null : 'equipment')}
      >
        <div className="flex items-center">
          <span className="font-medium text-lg">{title}</span>
        </div>
        <ChevronDown 
          size={20} 
          className={`transform transition-transform ${activeAccordion === 'equipment' ? 'rotate-180' : 'rotate-0'}`} 
        />
      </div>
      
      {activeAccordion === 'equipment' && (
        <div className="p-4">
          <div className="flex flex-col space-y-3">
            {EQUIPMENT_TYPES.map(equipment => (
              <div
                key={equipment.id}
                onClick={() => handleEquipmentClick(equipment)}
                className={`flex items-center p-3 rounded-lg cursor-pointer transition-all hover:scale-102 ${
                  darkMode ? 'bg-gray-700 hover:bg-gray-600' : 'bg-gray-50 hover:bg-gray-100'
                }`}
              >
                {/* Büyük görsel */}
                <div className="flex-shrink-0 mr-4 w-20 h-20 flex items-center justify-center overflow-hidden rounded-lg bg-gradient-to-br from-blue-50 to-blue-100 dark:from-blue-900/20 dark:to-blue-800/20">
                  <img 
                    src={equipment.imgSrc} 
                    alt={equipment.name} 
                    className="h-16 w-16 object-contain" 
                  />
                </div>
                {/* Yanındaki metin */}
                <div>
                  <div className={`font-medium text-lg ${darkMode ? 'text-gray-200' : 'text-gray-700'}`}>
                    {equipment.name}
                  </div>
                  <div className={`text-sm ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                    {equipment.description}
                  </div>
                </div>
              </div>
            ))}
          </div>
          
        </div>
      )}
    </div>
  );
};

export default EquipmentSelector;